(ns common.schema.entities.survey.survey-question.options
  "Option sets of the survey question: the data types that a question supports and that a
   user can create, the EDN templates, and the file types. The schema and the survey
   settings views read them from here.")

(def supported-data-types
  [:data.type/boolean
   :data.type/calculated-number
   :data.type/currency-value
   :data.type/currency-symbol
   :data.type/date
   :data.type/email
   :data.type/file
   :data.type/integer
   :data.type/ref-single
   :data.type/ref-multi
   :data.type/number
   :data.type/percentage
   :data.type/text
   :data.type/text-edn
   :data.type/text-multiline
   :data.type/text-simple
   :data.type/text-url
   :data.type/keyword
   :data.type/keyword-multi])

(def creatable-data-types
  (->> supported-data-types
       (remove #{:data.type/text-edn})))

(def supported-edn-templates
  [])

(def file-type-options
  (->> [:file.type/pdf
        :file.type/png
        :file.type/jpg
        :file.type/svg
        :file.type/webp
        :file.type/xls
        :file.type/doc
        :file.type/xlsx
        :file.type/docx]
       (mapv (fn [k]
               {:value k
                :label (name k)}))))
